import { TopBar } from './TopBar';
import { Main } from './Main';
import { HelpDialog } from './HelpDialog';
import { CaptureBadgeListener } from './CaptureBadgeListener';
import { AppConfigLoader } from './AppConfigLoader';
import { PreviewPane } from './PreviewPane';
import { PreviewSplitter } from './PreviewSplitter';
import { UndoToast } from './UndoToast';
import { CommandPalette } from './CommandPalette';
import { SubmitModalHost } from './SubmitModalHost';
import { useStore } from '../store';

export function Shell() {
  const previewOpen = useStore((s) => s.previewOpen);
  return (
    <div className="app">
      <TopBar />
      <div className={'shell' + (previewOpen ? ' shell-with-preview' : '')}>
        <Main />
        {previewOpen && <PreviewSplitter />}
        <PreviewPane />
      </div>
      <HelpDialog />
      <CaptureBadgeListener />
      <AppConfigLoader />
      <UndoToast />
      <CommandPalette />
      <SubmitModalHost />
    </div>
  );
}
